/* NUCLEAR OPTION - Complete Mobile Video Fix */
/* This completely overrides Shopify's video handling on mobile */

(function() {
  'use strict';
  
  // Check if we're on mobile
  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
           window.innerWidth <= 768;
  }
  
  // Only run on mobile
  if (!isMobile()) return;
  
  console.log('Mobile Video Fix: Running');
  
  function init() {
    // Wait a bit for Shopify to load everything
    setTimeout(function() {
      replaceDeferredMedia();
      addDirectVideoHandlers();
      forceVideosClickable();
    }, 500);
    
    // Also run after a longer delay to catch any late-loading elements
    setTimeout(function() {
      replaceDeferredMedia();
      addDirectVideoHandlers();
      forceVideosClickable();
    }, 2000);
  }
  
  // Method 1: Replace deferred-media entirely
  function replaceDeferredMedia() {
    const deferredMedias = document.querySelectorAll('deferred-media');
    
    deferredMedias.forEach(function(dm) {
      if (dm.getAttribute('data-video-fixed')) return; // Already fixed
      
      const template = dm.querySelector('template');
      if (!template) return;
      
      const templateContent = template.content || template;
      const iframe = templateContent.querySelector('iframe');
      
      if (iframe) {
        const videoUrl = iframe.getAttribute('src') || iframe.getAttribute('data-src');
        
        if (videoUrl && videoUrl.includes('youtube.com')) {
          console.log('Found YouTube video, replacing...');
          
          // Create a new clickable div
          const clickableDiv = document.createElement('div');
          clickableDiv.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 999;
            cursor: pointer;
            background: transparent;
          `;
          
          clickableDiv.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Video clicked!');
            loadVideoInline(dm, videoUrl);
          });
          
          clickableDiv.addEventListener('touchend', function(e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Video touched!');
            loadVideoInline(dm, videoUrl);
          });
          
          dm.style.position = 'relative';
          dm.appendChild(clickableDiv);
          dm.setAttribute('data-video-fixed', 'true');
        }
      }
    });
  }
  
  // Method 2: Add direct handlers to all video-related elements
  function addDirectVideoHandlers() {
    // Find all possible video containers
    const selectors = [
      '.product__media-item--video',
      '[data-media-type="video"]',
      '[data-media-type="external_video"]',
      '.deferred-media__poster',
      '.deferred-media__poster-button'
    ];
    
    selectors.forEach(function(selector) {
      const elements = document.querySelectorAll(selector);
      elements.forEach(function(element) {
        if (element.getAttribute('data-handler-added')) return;
        
        element.style.cursor = 'pointer';
        element.style.pointerEvents = 'auto';
        
        const handler = function(e) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Handler triggered on:', selector);
          
          // Find the closest deferred-media or video container
          let container = element.closest('deferred-media') || 
                         element.closest('.product__media-item') ||
                         element;
          
          const template = container.querySelector('template');
          if (template) {
            const iframe = template.content.querySelector('iframe') || 
                          template.querySelector('iframe');
            if (iframe) {
              const videoUrl = iframe.getAttribute('src') || iframe.getAttribute('data-src');
              if (videoUrl) {
                loadVideoInline(container, videoUrl);
              }
            }
          }
        };
        
        element.addEventListener('click', handler);
        element.addEventListener('touchend', handler);
        element.setAttribute('data-handler-added', 'true');
      });
    });
  }
  
  // Method 3: Force ALL videos to be clickable with CSS override
  function forceVideosClickable() {
    // Inject CSS to override any theme styles
    const style = document.createElement('style');
    style.textContent = `
      @media (max-width: 768px) {
        deferred-media,
        deferred-media *,
        .product__media-item--video,
        .product__media-item--video *,
        [data-media-type="video"],
        [data-media-type="external_video"],
        .deferred-media__poster,
        .deferred-media__poster-button {
          pointer-events: auto !important;
          touch-action: manipulation !important;
          cursor: pointer !important;
        }
        
        deferred-media {
          position: relative !important;
        }
        
        deferred-media::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 998;
          cursor: pointer;
        }
      }
    `;
    document.head.appendChild(style);
  }
  
  // Load video inline (replace thumbnail with actual video)
  function loadVideoInline(container, videoUrl) {
    console.log('Loading video:', videoUrl);
    
    // Modify URL to autoplay and unmute
    let finalUrl = videoUrl;
    
    // Remove any existing autoplay parameters
    finalUrl = finalUrl.replace(/[&?]autoplay=[01]/g, '');
    finalUrl = finalUrl.replace(/[&?]mute=[01]/g, '');
    
    // Add our parameters
    const separator = finalUrl.includes('?') ? '&' : '?';
    finalUrl += separator + 'autoplay=1&mute=0&playsinline=1&enablejsapi=1';
    
    // Create new iframe
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', finalUrl);
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('playsinline', '');
    iframe.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
      z-index: 1000;
    `;
    
    // Hide the poster/thumbnail
    const poster = container.querySelector('.deferred-media__poster');
    if (poster) {
      poster.style.display = 'none';
    }
    
    const posterButton = container.querySelector('.deferred-media__poster-button');
    if (posterButton) {
      posterButton.style.display = 'none';
    }
    
    // Remove any overlay divs we created
    const overlays = container.querySelectorAll('[data-video-fixed="true"] > div');
    overlays.forEach(function(overlay) {
      overlay.remove();
    });
    
    // Clear the container and add iframe
    const template = container.querySelector('template');
    if (template) {
      template.style.display = 'none';
    }
    
    container.appendChild(iframe);
    container.setAttribute('data-video-loaded', 'true');
    
    console.log('Video loaded successfully');
  }
  
  // Initialize everything
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-run on Shopify section updates
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  
  console.log('Mobile Video Fix: Initialized');
  
})();